module.exports = __webpack_public_path__ + "static/media/BlockchainBeyondTheHype.78647d5d.png";